import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import classNames from 'classnames';
import Edit from '@material-ui/icons/Edit';
import { Typography, Fab } from '@material-ui/core';

const Image = ({
  id, src, index, onHoverImage, onMoveImage, classes, onEdit,
}) => {
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: 'IMAGE',
    drop(item) {
      onMoveImage(item.index, index);
    },
    hover(item) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      onHoverImage(dragIndex, hoverIndex);

      item.index = hoverIndex; // eslint-disable-line
    },
  });
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'IMAGE', id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));
  const isOver = false;

  return (
    <div
      ref={ref}
      style={{ backgroundImage: `url('${src}')` }}
      className={classNames(classes.img, isOver && classes.isOver, isDragging && classes.move)}
    >
      <Typography className={classes.num}>
        #{id}
      </Typography>
      <Fab
        aria-label="Edit"
        className={classes.editButton}
        color="primary"
        size="small"
        onClick={onEdit}
      >
        <Edit />
      </Fab>
    </div>
  );
};

Image.propTypes = {
  id: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onHoverImage: PropTypes.func.isRequired,
  onMoveImage: PropTypes.func.isRequired,
  classes: PropTypes.shape({}),
  onEdit: PropTypes.func.isRequired,
};

export default Image;
